const typeOperation = {
  PAYMENT_USER: 1,
  CHARGE_WALLET_USER_VIA_ADMIN: 2,
  WITHDRAWAL_WALLET_USER_VIA_ADMIN: 3,
  GET_PLEDGE: 4,
  RETURN_PLEDGE: 5,
  WITHDRAWAL_WALLET_USER_EVERY_HOUR: 6,
  CHARGE_WALLET_USER_VIA_COWORKER: 7,
  WITHDRAWAL_WALLET_USER_VIA_COWORKER: 8,
  CONVERT_SCORE_PUBLISHER_TO_CHARGE_USER: 9,
  GIFT_FOR_USER_REGISTERED_BY_MARKETER: 10,
  INCREASE_WALLET_MARKETER_FOR_FIRST_PAYMENT_USER: 11,
  INCREASE_WALLET_MARKETER_FOR_SEVERAL_PAYMENT_USER: 12,
  INCREASE_WALLET_MARKETER_FOR_GIFT_REGISTER_USER_ADVERTISER: 13,
  INCREASE_WALLET_USER_FOR_GIFT_CHARGE_USER: 14,
};

const statusTypeOperation = () => {
  let data = {};
  data[typeOperation.PAYMENT_USER] = "پرداخت کاربر";
  data[typeOperation.CHARGE_WALLET_USER_VIA_ADMIN] =
    "افزایش حساب کاربر بوسیله مدیر";
  data[typeOperation.WITHDRAWAL_WALLET_USER_VIA_ADMIN] =
    "کاهش حساب کاربر بوسیله مدیر";
  data[typeOperation.GET_PLEDGE] = "گرفتن بیعانه";
  data[typeOperation.RETURN_PLEDGE] = "بازگشت بیعنه";
  data[typeOperation.WITHDRAWAL_WALLET_USER_EVERY_HOUR] =
    "برداشت هر ساعت به خاطر کمپین";

  data[typeOperation.CHARGE_WALLET_USER_VIA_COWORKER] =
    "اقزایش موجود کاربر بوسیله کاربر همکار";
  data[typeOperation.WITHDRAWAL_WALLET_USER_VIA_COWORKER] =
    "کاهش موجودی کاربر بوسیله کاربر همکار";
  data[typeOperation.CONVERT_SCORE_PUBLISHER_TO_CHARGE_USER] =
    "تبدیل امتیاز نمایش دهنده به موجودی تبلیغ دهنده";
  data[typeOperation.GIFT_FOR_USER_REGISTERED_BY_MARKETER] =
    "هدیه برای کاربران ثبت نام شده به وسیله بازاریاب";
  data[typeOperation.INCREASE_WALLET_MARKETER_FOR_FIRST_PAYMENT_USER] =
    "افزایش موجودی بازاریاب به دلیل اولین پرداخت کاربر";
  data[typeOperation.INCREASE_WALLET_MARKETER_FOR_SEVERAL_PAYMENT_USER] =
    "افزایش موجودی بازاریاب به دلیل پرداخت های ثانویه";
  data[
    typeOperation.INCREASE_WALLET_MARKETER_FOR_GIFT_REGISTER_USER_ADVERTISER
  ] = "افزایش حساب هدیه ثبت نام کاربر تبلیغ دهنده";
  data[typeOperation.INCREASE_WALLET_USER_FOR_GIFT_CHARGE_USER] =
    "افزایش موجودی کاربر به دلیل هدیه افزایش اعتبار";
  return data;
};

export default {
  typeOperation,
  statusTypeOperation,
};
